import React, {useEffect} from 'react';
import {Redirect, useParams} from 'react-router';
import {buildRoute} from '../navigation/navigationUtils';
import {DASHBOARD_ROUTES} from '../navigation/dashboard/DashboardRoutes';
import {usePulsoidClient} from '../../PulsoidClient';
import {Loader} from '../../system/Loader/Loader';

export const CloneWidget = () => {
  const [newWidgetId, setNewWidgetId] = React.useState<string | null>(null);
  const pulsoidClient = usePulsoidClient();
  const {predefinedWidgetId} = useParams<{predefinedWidgetId: string}>();

  useEffect(() => {
    const fetchData = async () => {
      try {
        const {clonedWidgetId} = await pulsoidClient.cloneWidget(
          predefinedWidgetId
        );
        setNewWidgetId(clonedWidgetId);
      } catch (error) {
        console.error('Error copying widget', error);
      }
    };

    fetchData();
  }, [predefinedWidgetId, pulsoidClient]);

  if (!newWidgetId) {
    return <Loader loading description="Initializing new widget" />;
  }

  return (
    <Redirect
      to={{
        pathname: buildRoute({
          path: DASHBOARD_ROUTES.CONFIGURATION_EDIT_WIDGET,
          params: {id: newWidgetId},
        }),
      }}
    />
  );
};
